// @flow

export default (
  disallowedIntegrationTypes: Array<string>,
  stateIntegrationType: ?string,
  isAdmin: boolean
): boolean =>
  !disallowedIntegrationTypes.length ||
  !stateIntegrationType ||
  !disallowedIntegrationTypes.includes(stateIntegrationType.toLowerCase()) ||
  isAdmin;
